import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Button, Select } from '@chilecompra/react-kit/components'
import { DOWNLOADS_MONTH_OPTIONS, DOWNLOADS_REPORT_TYPE_OPTIONS } from '../../config/settings/constants'
import { REACT_APP_TCHC_BLOB_URL } from '../../config/settings/environment'
import {
  BuildIcon,
  Clipboard,
  ClipboardAction,
  ClipboardIcon,
  ClipboardText,
  Description,
  GridContainer,
  GridItem,
  Info,
  InfoText,
  Label,
  PreviewIcon
} from './DownloadOrdersAndBiddingsSection.styles'

/**
 * The Massive's component.
 */
const Massive = props => {
  const {
    monthValue,
    reportTypeValue,
    yearValue,
    yearsOptions,
    onChangeMonth,
    onChangeReportType,
    onChangeYear,
    onClickDownload,
    onDoubleClickClipboard,
    onOpenBuildDialog,
    onOpenPreviewDialog
  } = props
  const downloadUrl = useMemo(() => {
    const parsedMonthValue = Number.parseInt(monthValue, 10)

    return `${REACT_APP_TCHC_BLOB_URL}/${reportTypeValue || '[TipoReporte]'}/${
      yearValue || '[Año]'
    }-${parsedMonthValue}.zip`
  }, [monthValue, reportTypeValue, yearValue])
  const isCurrentYear = useMemo(() => yearValue === new Date().getFullYear(), [yearValue])
  const monthOptions = useMemo(
    () =>
      isCurrentYear
        ? DOWNLOADS_MONTH_OPTIONS.filter((_, index) => index <= new Date().getMonth())
        : DOWNLOADS_MONTH_OPTIONS,
    [isCurrentYear]
  )

  return (
    <>
      <GridContainer padding="0 0 27px">
        <GridItem xs={12}>
          <Description>
            Utiliza los filtros y descarga de forma masiva archivos comprimidos en formato .zip que contienen reportes
            que incluyen toda la información de todos los organismos del Estado que transan en Mercado Público, tanto
            para órdenes de compra como licitaciones.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 15px" spacing={1}>
        <GridItem xs={12} md={4}>
          <Select
            label="TIPO DE REPORTE"
            options={DOWNLOADS_REPORT_TYPE_OPTIONS}
            value={reportTypeValue}
            onChange={onChangeReportType}
          />
        </GridItem>
        <GridItem xs={12} md={4}>
          <Select label="AÑO" options={yearsOptions} value={yearValue} onChange={onChangeYear} />
        </GridItem>
        <GridItem xs={12} md={4}>
          <Select label="MES" options={monthOptions} value={monthValue} onChange={onChangeMonth} />
        </GridItem>
      </GridContainer>
      <GridContainer alignItems="flex-end" spacing={1}>
        <GridItem xs={12} md={8}>
          <Label>Copia la siguiente URL en tu navegador o descarga directamente el archivo</Label>
          <Clipboard onDoubleClick={onDoubleClickClipboard(downloadUrl)}>
            <ClipboardText>{downloadUrl}</ClipboardText>
            <ClipboardAction>
              <ClipboardIcon />
            </ClipboardAction>
          </Clipboard>
        </GridItem>
        <GridItem align="right" xs={12} md={4}>
          <Button color="primary" disabled={!yearValue} onClick={onClickDownload(yearValue, downloadUrl)}>
            Descargar archivo
          </Button>
        </GridItem>
      </GridContainer>
      <GridContainer spacing={1}>
        <GridItem xs={8}>
          <Info onClick={onOpenBuildDialog}>
            <BuildIcon />
            <InfoText>Conoce como se construye esta URL</InfoText>
          </Info>
          <Info onClick={onOpenPreviewDialog}>
            <PreviewIcon />
            <InfoText>Vista previa del reporte</InfoText>
          </Info>
        </GridItem>
        <GridItem xs={4} />
      </GridContainer>
    </>
  )
}

Massive.propTypes = {
  monthValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  reportTypeValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  yearValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  yearsOptions: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ).isRequired,
  onChangeMonth: PropTypes.func.isRequired,
  onChangeReportType: PropTypes.func.isRequired,
  onChangeYear: PropTypes.func.isRequired,
  onClickDownload: PropTypes.func.isRequired,
  onDoubleClickClipboard: PropTypes.func.isRequired,
  onOpenBuildDialog: PropTypes.func.isRequired,
  onOpenPreviewDialog: PropTypes.func.isRequired
}

export default Massive
